import { CertificateExpiryHeader } from "./components/CertificateExpiryHeader";
import { CertificateExpiryContent } from "./components/CertificateExpiryContent";
import { JSX } from "react";

export const CertificateExpiryPageContainer = (): JSX.Element => {
    return (
        <div className="p-certificate-expiry">
            <CertificateExpiryHeader />
            <CertificateExpiryContent />
        </div>
    );
};
